import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import VersionSelector from '../shared/VersionSelector';
import {
  addCommas,
  compare,
  storeWithExpiration,
  renderDisabledStatus,
  renderEnabledStatus,
  renderRLTLabel,
} from '../../utils/common';
import {
  EDIT_GROUP_PAGE,
  EDIT_SKU_PAGE,
  FIELDSET_TYPE_GROUP,
  FIELDSET_TYPE_SKU,
  NEW_GROUP_PAGE,
  NEW_SKU_PAGE,
} from '../../config/app_config';

export default class SingleDataset extends React.Component {
  static propTypes = {
    dataSet: PropTypes.object.isRequired,
    datasetId: PropTypes.string.isRequired,
    fieldSets: PropTypes.object.isRequired,
    goToEditFieldsetFunction: PropTypes.func.isRequired,
    handleVersionSelectChange: PropTypes.func.isRequired,
    isAdminPage: PropTypes.bool.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSalesOps: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isTechnicalOps: PropTypes.bool.isRequired,
    openConfigFormFunction: PropTypes.func,
    openDatasetReportsPageFunction: PropTypes.func.isRequired,
    openEditListFunction: PropTypes.func.isRequired,
    openFilesetPageFunction: PropTypes.func,
    openFilesetPreviewFunction: PropTypes.func.isRequired,
    openGroupCreationFunction: PropTypes.func.isRequired,
    openSkuCreationFunction: PropTypes.func,
    platforms: PropTypes.object,
    recordsSummary: PropTypes.object.isRequired,
    selectedVersion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setSelectedVersion: PropTypes.func.isRequired,
    toggleDialogFunction: PropTypes.func.isRequired,
    togglePreviewDialogFunction: PropTypes.func.isRequired,
    versionsSummary: PropTypes.object.isRequired,
  };

  static defaultProps = {
    openConfigFormFunction: null,
    openFilesetPageFunction: null,
    openSkuCreationFunction: null,
    platforms: null,
    selectedVersion: null,
  };

  constructor(props) {
    super(props);
    this.handlePlatformSelectChange = this.handlePlatformSelectChange.bind(this);
  }

  state = { selectedPlatform: '' };

  componentWillMount = () => {
    const { platforms, versionsSummary, datasetId, setSelectedVersion } = this.props;
    const versions = versionsSummary.get(datasetId);

    if (versions && versions.length > 0) {
      const value = versions.filter(v => v.status === 1)[0].id;
      setSelectedVersion(value);
    }

    // There are only platforms options on the superadmin side
    if (platforms && platforms.size > 0) {
      this.setState({ selectedPlatform: platforms.first().code });
    }
  };

  performOpenEditList = (datasetId, isSuperAdmin) => {
    const { openEditListFunction } = this.props;
    openEditListFunction(datasetId, isSuperAdmin);
  };

  openConfigureListForm = (platformCode, datasetId) => {
    const { openConfigFormFunction } = this.props;
    openConfigFormFunction(platformCode, datasetId);
  };

  performOpenFilesetPage = (datasetId, datasetName) => {
    const { openFilesetPageFunction } = this.props;
    openFilesetPageFunction(datasetId, datasetName);
  };

  performOpenSkuCreationPage = (datasetId, datasetName) => {
    const { openSkuCreationFunction } = this.props;
    openSkuCreationFunction(datasetId, datasetName);
  };

  performOpenFilesetPreview = dataset => {
    const { openFilesetPreviewFunction } = this.props;
    const token = storeWithExpiration.get('token');
    openFilesetPreviewFunction(token, dataset);
  };

  performOpenReports = dataset => {
    const { openDatasetReportsPageFunction } = this.props;
    openDatasetReportsPageFunction(dataset.id);
  };

  goToEditPage = (fieldsetId, datasetId, page) => {
    const { goToEditFieldsetFunction, isAdminPage } = this.props;
    goToEditFieldsetFunction(fieldsetId, datasetId, page, isAdminPage);
  };

  performOpenGroupCreation = (datasetId, datasetName) => {
    const { openGroupCreationFunction } = this.props;
    openGroupCreationFunction(datasetId, datasetName);
  };

  handlePlatformSelectChange = e => {
    this.setState({ selectedPlatform: e.target.value });
  };

  renderFileSetCounts = record => {
    const fileset = record.get('fileSet');
    const countName = renderRLTLabel(fileset.get('recordLevelType'));
    const recordCount = record.get('count');

    return (
      <div className="col-sm-3">
        <div className="card-border">
          <div className="card-block">
            <div className="row align-items-center">
              <div className="col-sm-12">
                <h8 className="card-title text-uppercase text-muted mb-2">
                  Total {countName} Records
                </h8>
                <p className="h2 mb-0">
                  {recordCount === undefined ? 'Not Available' : addCommas(recordCount)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render sku or group based on type
  renderFieldset = (fieldset, fieldsetType, datasetId, datasetName, datasetState) => {
    // TODO: update this so that the dialog shows depending on whether the sku is in use or not
    const {
      toggleDialogFunction,
      togglePreviewDialogFunction,
      isSuperAdmin,
      isProviderAdmin,
      isSalesOps,
      isTechnicalOps,
    } = this.props;
    const editPage = fieldsetType === FIELDSET_TYPE_SKU ? EDIT_SKU_PAGE : EDIT_GROUP_PAGE;
    // Only render the requested fieldset (Group or SKU)
    if (fieldsetType !== fieldset.setType) return null;

    return (
      <tr key={fieldset.id} style={{ maxHeight: 5 }}>
        <td>
          <p className="table-text">{fieldset.name}</p>
        </td>
        <td>
          <p>{fieldset.fieldCount} Fields</p>
        </td>
        <td>
          <span>
            <span className="">
              {(datasetState === 'APPROVED' && isSuperAdmin) ||
              isProviderAdmin ||
              isTechnicalOps ||
              isSalesOps ? (
                <button
                  className="btn btn-primary-outline"
                  onClick={e => {
                    e.preventDefault();
                    if (fieldset.installedCount > 0) {
                      toggleDialogFunction('editSkuDialog');
                    } else {
                      this.goToEditPage(fieldset.id, datasetId, editPage);
                    }
                  }}
                >
                  Edit
                </button>
              ) : null}
            </span>
          </span>
        </td>
        <td>
          <button
            className="btn btn-primary-outline"
            onClick={e => {
              e.preventDefault();
              togglePreviewDialogFunction(
                fieldset,
                datasetId,
                datasetName,
                datasetState,
                'skuPreviewDialog'
              );
            }}
          >
            Preview
          </button>
        </td>
      </tr>
    );
  };

  renderConfigure = datasetId => {
    const { platforms } = this.props;
    return (
      <div>
        <p>
          <select
            className="form-control field-inline"
            value={this.state.selectedPlatform}
            onChange={this.handlePlatformSelectChange}
          >
            {platforms === undefined || platforms.length === 0 ? (
              <option>There are currently no Platforms </option>
            ) : (
              platforms.map(this.renderPlatform)
            )}
          </select>
          &nbsp;
          <button
            type="button"
            className="btn btn-default btn-md"
            onClick={() => {
              this.openConfigureListForm(this.state.selectedPlatform, datasetId);
            }}
          >
            Configure
          </button>
        </p>
      </div>
    );
  };

  renderPlatform = platform => (
    <option key={platform.id} value={platform.code}>
      {platform.description}
    </option>
  );

  renderVersion = version => {
    const createdOn = new Date(version.createdOn);
    const formattedDate = createdOn.toUTCString();

    // Currently, versions have no "title" attribute
    return (
      <option key={version.id} value={version.id}>
        {version.status === 1 ? 'Current ' : ''}
        Version (#{version.version}) ( {formattedDate} )
      </option>
    );
  };

  render() {
    const {
      dataSet,
      datasetId,
      fieldSets,
      handleVersionSelectChange,
      isProviderAdmin,
      isTechnicalOps,
      isSalesOps,
      isSuperAdmin,
      recordsSummary,
      selectedVersion,
      versionsSummary,
    } = this.props;
    let groups;
    let dataSkus;
    if (fieldSets) {
      groups = fieldSets.filter(fieldset => fieldset.setType === FIELDSET_TYPE_GROUP);
      dataSkus = fieldSets.filter(fieldset => fieldset.setType === FIELDSET_TYPE_SKU);
    }
    const tableId = 'table'.concat(dataSet.index);
    const versions = versionsSummary.get(datasetId);
    const records = recordsSummary.get(datasetId);
    const isAllowedEdit = isSuperAdmin || isProviderAdmin || isTechnicalOps;
    if (versions) versions.sort(compare);

    return (
      <div className="col-sm-12">
        <div className="card-border row">
          <div className="card-header">
            <div className="card-header-title">{dataSet.name}</div>
          </div>
          <div className="card-block">
            <div className="row">
              {records && records.size > 0
                ? records.valueSeq().map(this.renderFileSetCounts)
                : null}
            </div>
            <hr />
            <dl className="row">
              <dt className="col-sm-3">Live Version</dt>
              <dd className="col-sm-9">
                {isAllowedEdit ? (
                  <p>
                    <VersionSelector
                      handleOnChange={handleVersionSelectChange}
                      selectedVersion={selectedVersion}
                      versions={versions}
                    />
                    <br />
                  </p>
                ) : null}
              </dd>

              {isSuperAdmin ? <dt className="col-sm-3">Configure Platform</dt> : null}
              {isSuperAdmin ? (
                <dd className="col-sm-9">{this.renderConfigure(dataSet.id)}</dd>
              ) : null}

              <dt className="col-sm-3">Status</dt>
              <dd className="col-sm-9">
                {dataSet.status === 0 ? renderDisabledStatus() : renderEnabledStatus()}
              </dd>
            </dl>
            <hr />
            <p>
              <button
                type="button"
                className="btn btn-default btn-md"
                disabled={dataSet.state !== 'APPROVED'}
                onClick={() => {
                  this.performOpenFilesetPreview(dataSet);
                }}
              >
                Preview Data
              </button>
              {isSuperAdmin ? (
                <button
                  type="button"
                  className="btn btn-default btn-md"
                  onClick={() => this.performOpenFilesetPage(dataSet.id, dataSet.name)}
                >
                  View Filesets
                </button>
              ) : null}
              {isSuperAdmin || isProviderAdmin || isTechnicalOps ? (
                <button
                  type="button"
                  className="btn btn-default btn-md"
                  disabled={dataSet.state !== 'APPROVED'}
                  onClick={() => {
                    this.performOpenReports(dataSet);
                  }}
                >
                  View Reports
                </button>
              ) : null}
              {isAllowedEdit ? (
                <button
                  type="button"
                  className="btn btn-default btn-md"
                  disabled={!isSuperAdmin && dataSet.state !== 'APPROVED'}
                  onClick={() => this.performOpenEditList(dataSet.id, isSuperAdmin)}
                >
                  Edit List
                </button>
              ) : null}
            </p>
          </div>
        </div>
        <div className="card-border row">
          <div className="card-header">
            <div className="card-header-title">Manage SKUs</div>
          </div>
          <div className="card-block">
            <div id="SKUs" className="pre-scrollable">
              {dataSkus === undefined || dataSkus.size === 0 ? (
                <tr>
                  <td>
                    <p>There are no SKUs associated with this dataset</p>
                  </td>
                </tr>
              ) : (
                <table className="table">
                  <thead>
                    <tr>
                      <th>SKU Name</th>
                      <th>Total Fields</th>
                      <th>Edit</th>
                      <th>Preview</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataSkus
                      .valueSeq()
                      .map(sku =>
                        this.renderFieldset(
                          sku,
                          FIELDSET_TYPE_SKU,
                          dataSet.id,
                          dataSet.name,
                          dataSet.state
                        )
                      )}
                  </tbody>
                </table>
              )}
              {isSuperAdmin || isProviderAdmin || isTechnicalOps || isSalesOps ? <hr /> : null}
              {isSuperAdmin || isProviderAdmin || isTechnicalOps || isSalesOps ? (
                <Link
                  to={`/data/dataset/${dataSet.id}/${NEW_SKU_PAGE}`}
                  className="btn btn-default btn-md"
                  disabled={dataSet.state !== 'APPROVED'}
                >
                  New SKU
                </Link>
              ) : null}
            </div>
          </div>
        </div>
        <div className="card-border row">
          <div className="card-header">
            <div className="card-header-title">Manage Groups</div>
          </div>
          <div className="card-block">
            {groups === undefined || groups.size === 0 ? (
              <tr>
                <td>
                  <p>There are no groups associated with this dataset</p>
                </td>
              </tr>
            ) : (
              <table className="table" id={tableId} key={tableId}>
                <tbody>
                  {groups
                    .valueSeq()
                    .map(group =>
                      this.renderFieldset(
                        group,
                        FIELDSET_TYPE_GROUP,
                        dataSet.id,
                        dataSet.name,
                        dataSet.state
                      )
                    )}
                </tbody>
              </table>
            )}
            {isSuperAdmin || isProviderAdmin || isTechnicalOps || isSalesOps ? <hr /> : null}
            {isSuperAdmin || isProviderAdmin || isTechnicalOps || isSalesOps ? (
              <Link
                to={`/data/dataset/${dataSet.id}/${NEW_GROUP_PAGE}`}
                className="btn btn-default btn-md"
              >
                New Group
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
